// extracted by mini-css-extract-plugin
export default {"vacancies-page":"VacancyPage_vacancies-page__fhovg","vacancies-title":"VacancyPage_vacancies-title__Ygtj2"};